import { usePackageReview, type ReviewInput } from './usePackageReview'
import { PackageReviewWorkspace } from './PackageReviewWorkspace'
export { CandidateSelect } from './CandidateSelect'
export { emptyChoices } from './usePackageReview'
export default function PackageReview(input: ReviewInput & { onReceiptSaved?: () => void }) {
  const controller = usePackageReview(input)
  return <PackageReviewWorkspace controller={controller} onReceiptSaved={input.onReceiptSaved} />
}
